export default __webpack_public_path__ + "locales/identifiers-next.ru.json";